import axios from "axios";

const actionGetReports = async ({commit}, payload) => {
  const results = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/rmpi`, {params:payload})
  commit("SET_REPORT_RESULTS", results.data);
}

export default {
  actionGetReports
}